export const fullscreenContract = {
	className: 'icon-fullscreen-contract',
	viewBox: '0 0 223.26501 223.27201',
	transform: 'translate(-28.004,-33.177)',
	paths: [
		'm 207.306,77.146 0,-43.969 14.768,0 0,29.201 29.195,0 0,14.768 -43.963,0 z',
		'm 222.074,227.254 29.195,0 0,-14.774 -43.963,0 0,43.968 14.768,0 0,-29.194 z',
		'm 57.199,256.449 14.768,0 0,-43.969 -43.963,0 0,14.774 29.195,0 0,29.195 z',
		'm 71.967,33.177 -14.768,0 0,29.201 -29.195,0 0,14.768 43.963,0 0,-43.969 z'
	]
}
